export const IMAGE_UPLOAD_ERROR = "Something went wrong while uploading the image."